import styled, { css } from 'styled-components'

import { values } from '@chegg-wt/core/theme/sunkist/spacing'
import { MenuItem } from '@chegg-wt/core/theme/sunkist/menu'
import { NormalRounding } from '@chegg-wt/core/theme/sunkist/borders'
import { LargeLink } from '@chegg-wt/core/theme/sunkist/link'
import { Ellipsize } from '@chegg-wt/core/theme/sunkist/typography'

import {
  Icon as FIcon,
  ListContainer as FListContainer,
  ButtonContainer,
} from '@chegg-wt/core/components/Folders/styled'

export const ProjectMenuContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const Icon = styled(FIcon)``

export const Label = styled.span`
  ${Ellipsize};
`

export const CreateFolderAction = styled(ButtonContainer)`
  ${LargeLink};
  padding: ${values.xxsmall};
`

export const ItemAction = styled(ButtonContainer)`
  display: flex;

  & > * {
    flex: 0 0 auto;
  }

  & > ${Label} {
    flex: 1 1 auto;
  }

  & > * + * {
    margin-left: ${values.xsmall};
  }
  :focus {
    outline: none;
  }
`

const ListItemAppearance = css`
  ${MenuItem};
  ${NormalRounding};
`

const ListItemLayout = css`
  display: flex;

  & > * {
    flex: 1 1 auto;
    min-width: 0;
  }
`

export const ListItem = styled.li`
  ${ListItemLayout};
  ${ListItemAppearance};
`

export const ListContainer = styled(FListContainer)``

export const FoldersListGroup = styled.div`
  & > * + * {
    margin-top: ${values.xsmall};
  }
`
